import React from "react";
import { Link } from "react-router-dom";
import { useLanguage } from "../i18n/LanguageContext";
import { Instagram, Youtube, Facebook, MessageCircle } from "lucide-react";

const SOCIALS = [
  { key: "instagram", icon: Instagram, url: "https://www.instagram.com/lifegreenhorizon/", label: "Instagram" },
  { key: "youtube", icon: Youtube, url: "https://www.youtube.com/@GreenHorizonLive", label: "YouTube" },
  { key: "facebook", icon: Facebook, url: "https://www.facebook.com/greenhorizonlife/", label: "Facebook" },
  { key: "whatsapp", icon: MessageCircle, url: "https://wa.me/4935116087387", label: "WhatsApp" },
];

const Footer = ({ variant = "entry" }) => {
  const { t } = useLanguage();
  const isMen = variant === "men";
  const isWomen = variant === "women";
  const wrap = isMen
    ? "border-[#2C313D] text-[#8A91A5] bg-[#0F1014]"
    : isWomen
    ? "border-[#D5CECA] text-[#5C6660] bg-[#F4F1ED]"
    : "border-neutral-200 text-neutral-500 bg-white";
  const accent = isMen ? "#D4AF37" : isWomen ? "#738678" : "#111";
  const iconHover = isMen ? "hover:text-[#D4AF37]" : isWomen ? "hover:text-[#738678]" : "hover:text-black";

  return (
    <footer
      data-testid={`site-footer-${variant}`}
      className={`mt-24 border-t ${wrap} px-6 md:px-12 lg:px-20 py-12 text-xs md:text-sm`}
    >
      {/* socials */}
      <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-8 pb-8 border-b" style={{ borderColor: isMen ? "#2C313D" : isWomen ? "#D5CECA" : "#E5E5E5" }}>
        <div>
          <p className="eyebrow" style={{ color: accent }}>Folge auf Social</p>
          <p className="mt-3 text-base md:text-lg" style={{ color: isMen ? "#FFFFFF" : "#2C332E" }}>
            Tiefenentspannungen, Coaching-Impulse & Live-Sessions
          </p>
        </div>
        <div className="flex items-center gap-3" data-testid="social-icons">
          {SOCIALS.map(({ key, icon: Icon, url, label }) => {
            const disabled = !url;
            const className = `w-11 h-11 rounded-full border flex items-center justify-center transition ${iconHover} ${disabled ? "opacity-30 cursor-not-allowed" : "opacity-90 hover:opacity-100"}`;
            const style = { borderColor: isMen ? "#2C313D" : isWomen ? "#D5CECA" : "#E5E5E5" };
            return disabled ? (
              <span key={key} data-testid={`social-${key}-disabled`} className={className} style={style} title="Bald verfügbar" aria-label={`${label} (bald verfügbar)`}>
                <Icon size={18} />
              </span>
            ) : (
              <a key={key} href={url} target="_blank" rel="noreferrer" data-testid={`social-${key}`} className={className} style={style} aria-label={label} title={label}>
                <Icon size={18} />
              </a>
            );
          })}
        </div>
      </div>

      {/* meta */}
      <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-4 pt-8">
        <p className="opacity-80">© {new Date().getFullYear()} · {t.footer.built}</p>
        <div className="flex items-center gap-6 uppercase tracking-[0.22em] text-[0.7rem]">
          <Link data-testid="footer-imprint" to="/impressum" className="hover:opacity-100 opacity-70 transition">{t.footer.imprint}</Link>
          <Link data-testid="footer-privacy" to="/datenschutz" className="hover:opacity-100 opacity-70 transition">{t.footer.privacy}</Link>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
